import { db } from '../auth/firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const ADMIN_EMAIL = 'tomjwesley@gmail.com';
const ROLES_COLLECTION = 'ubunited_roles';

export async function seedInitialAdmin(currentUser) {
  if (!currentUser || currentUser.email !== ADMIN_EMAIL) return false;

  try {
    const roleRef = doc(db, ROLES_COLLECTION, currentUser.uid);
    const roleSnap = await getDoc(roleRef);

    if (!roleSnap.exists() || roleSnap.data().role !== 'super_admin') {
      await setDoc(roleRef, {
        email: ADMIN_EMAIL,
        role: 'super_admin',
        grantedBy: 'system',
        grantedAt: new Date().toISOString(),
        active: true,
      });
      return true;
    }
    return false;
  } catch (error) {
    console.error('Seed admin error:', error);
    return false;
  }
}
